// Localized one-line descriptions of the 30 power elements. Ported verbatim
// from discovery's i18n bundles (enum.creativityelement.desc.* in
// messages_de/_en.properties) - genesis has no API for these texts.

export const ELEMENT_DESCRIPTIONS: Record<string, { de: string; en: string }> = {
  PERSEVERANCE: {
    de: "Ausdauer ist die Fähigkeit, über einen längeren Zeitraum hinweg kontinuierlich an einer Aufgabe oder einem Ziel festzuhalten, trotz möglicher Ermüdung oder Rückschläge.",
    en: "Perseverance is the ability to persist in pursuing a task or goal over an extended period, despite fatigue or setbacks.",
  },
  MINDFULNESS: {
    de: "Achtsamkeit ist die bewusste Lenkung der Aufmerksamkeit auf den gegenwärtigen Moment.",
    en: "Mindfulness is the conscious directing of attention to the present moment.",
  },
  ADAPTION: {
    de: "Adaption ist die Fähigkeit, Denk- und Handlungsweisen flexibel an neue Anforderungen, Informationen oder Umgebungen anzupassen.",
    en: "Adaptation is the ability to flexibly adjust thinking and behavior to new demands, information or environments.",
  },
  CONCENTRATION: {
    de: "Konzentration ist die Fähigkeit, die Aufmerksamkeit gezielt und über einen bestimmten Zeitraum auf eine Aufgabe oder einen Reiz zu richten.",
    en: "Concentration is the ability to focus attention purposefully on a task or stimulus over a period of time.",
  },
  AGGRESSION: {
    de: "Aggression ist die Kraft der körperlichen und geistigen Gewalt zur Durchbrechung gegengerichteter Interessen",
    en: "Aggression is the force of physical and mental violence used to break through opposing interests.",
  },
  INTENTION: {
    de: "Intention ist die bewusste innere Ausrichtung auf ein Ziel oder eine Handlung.",
    en: "Intention is the conscious inner orientation toward a goal or an action.",
  },
  DILIGENCE: {
    de: "Sorgfalt ist die bewusste, genaue und verantwortungsvolle Anwendung von Wissen und Denken bei der Lösung von Aufgaben oder Entscheidungen.",
    en: "Diligence is the conscious, precise and responsible application of knowledge and thinking in solving tasks or making decisions.",
  },
  STRATEGY: {
    de: "Strategie ist ein langfristig ausgerichteter Plan oder ein Vorgehensmodell, das dazu dient, ein definiertes Ziel effizient zu erreichen.",
    en: "Strategy is a long-term plan or approach designed to efficiently achieve a defined goal.",
  },
  RESPONSIBILITY: {
    de: "Verantwortung ist die Bereitschaft und Fähigkeit, für das eigene Handeln und dessen Folgen einzustehen.",
    en: "Responsibility is the willingness and ability to be accountable for one's actions and their consequences.",
  },
  CHARISMA: {
    de: "Charisma ist die Fähigkeit einer Person, durch Auftreten und Ausdruck eine starke Wirkung auf andere auszuüben.",
    en: "Charisma is a person's ability to exert a strong influence on others through demeanor and expression.",
  },
  COURAGE: {
    de: "Mut ist die Fähigkeit, in schwierigen Situationen entschlossen zu handeln - trotz Angst, Zweifel oder Risiko.",
    en: "Courage is the ability to act decisively in difficult situations - despite fear, doubt or risk.",
  },
  FAITH: {
    de: "Glaube ist die innere Überzeugung von der Wahrheit oder Gültigkeit einer Idee, einer Person oder einer höheren Wirklichkeit - unabhängig von empirischen Beweisen.",
    en: "Belief is the inner conviction in the truth or validity of an idea, a person or a higher reality - independent of empirical evidence.",
  },
  CURIOSITY: {
    de: "Neugierde ist das innere Bedürfnis, Neues zu erfahren, Unbekanntes zu erkunden und Wissen zu erweitern.",
    en: "Curiosity is the internal drive to discover new things, explore the unknown and expand one's knowledge.",
  },
  ABSTRACTION: {
    de: "Abstraktion ist die Fähigkeit, reale Prozesse und Gegebenheiten in Muster, Zeichen und Symbole zu überführen, um sie als Sprache zu nutzen und zur Simulation von Realität weiterzuentwickeln.",
    en: "Abstraction is the ability to transform real processes and conditions into patterns, signs and symbols in order to use them as language and further develop them as a simulation of reality.",
  },
  PASSION: {
    de: "Passion ist ein intensives inneres Engagement für eine Tätigkeit, ein Thema oder eine Person, das mit starker Emotion und Hingabe verbunden ist.",
    en: "Passion is an intense inner commitment to an activity, subject or person, accompanied by strong emotion and dedication.",
  },
  IMAGINATION: {
    de: "Imagination ist die Fähigkeit, mithilfe der Fantasie innere Bilder, Ideen oder Szenarien zu erschaffen, die nicht real vorhanden sind.",
    en: "Imagination is the ability to use fantasy to create inner images, ideas or scenarios that are not physically present.",
  },
  INSPIRATION: {
    de: "Inspiration ist ein plötzlicher Impuls oder eine Idee, die Kreativität und Handeln antreibt.",
    en: "Inspiration is a sudden impulse or idea that drives creativity and action.",
  },
  IMPROVISATION: {
    de: "Improvisation ist die spontane und situationsbezogene Gestaltung von Handlungen oder Lösungen ohne feste Vorbereitung.",
    en: "Improvisation is the spontaneous and situation-based creation of actions or solutions without prior planning.",
  },
  AUTONOMY: {
    de: "Autonomie ist die Fähigkeit und das Recht, eigenständig Entscheidungen zu treffen und das eigene Handeln selbstbestimmt zu gestalten.",
    en: "Autonomy is the ability and the right to make independent decisions and to govern one's actions in a self-determined manner.",
  },
  INTUITION: {
    de: "Intuition ist die Fähigkeit, Entscheidungen oder Einsichten ohne bewusstes Nachdenken zu erfassen.",
    en: "Intuition is the ability to perceive decisions or insights without conscious reasoning.",
  },
  TOLERANCE: {
    de: "Toleranz ist die Haltung, Unterschiede, abweichende Meinungen, Lebensweisen und Überzeugungen auszuhalten, zu respektieren und anderen Freiheit zuzugestehen.",
    en: "Tolerance is the attitude of enduring and respecting differences, dissenting opinions, ways of life and convictions, and granting others freedom.",
  },
  EMPATHY: {
    de: "Empathie ist die Fähigkeit, die Gefühle, Gedanken und Perspektiven anderer Menschen nachzuempfinden und zu verstehen.",
    en: "Empathy is the ability to understand and share the feelings, thoughts and perspectives of others.",
  },
  HUMOR: {
    de: "Humor ist die Kraft des Lachens und der inneren Leichtigkeit.",
    en: "Humor is the power of laughter and inner lightness.",
  },
  FIDELITY: {
    de: "Treue ist die beständige innere Verbundenheit und Verlässlichkeit gegenüber einer Person, Idee oder Verpflichtung.",
    en: "Fidelity is the consistent inner commitment and reliability toward a person, idea or obligation.",
  },
  FAIRNESS: {
    de: "Fairness ist ein Verhalten, das auf Gleichbehandlung, Gerechtigkeit und Einhaltung gemeinsamer Regeln abzielt.",
    en: "Fairness is a behavior aimed at equal treatment, justice and adherence to shared rules.",
  },
  SELF_AWARENESS: {
    de: "Selbstwahrnehmung ist die Fähigkeit, die eigenen Gefühle, Gedanken und Verhaltensweisen bewusst zu erkennen und zu reflektieren.",
    en: "Self-perception is the ability to consciously recognize and reflect on one's own emotions, thoughts and behaviors.",
  },
  PERCEPTION: {
    de: "Wahrnehmung ist der Prozess, bei dem Sinnesreize aufgenommen, verarbeitet und als Eindrücke bewusst erlebt werden.",
    en: "Perception is the process by which sensory stimuli are received, processed and consciously experienced as impressions.",
  },
  LANGUAGE: {
    de: "Sprache ist ein systematisches, regelgeleitetes Zeichensystem, mit dem Menschen Gedanken, Gefühle und Informationen ausdrücken, vermitteln und verstehen können.",
    en: "Language is a systematic, rule-governed system of signs that enables people to express, convey, and understand thoughts, feelings, and information.",
  },
  EXPRESSION: {
    de: "Expression ist die sichtbare oder hörbare Äußerung innerer Zustände wie Gefühle, Gedanken oder Absichten durch Mimik, Sprache oder Gestik.",
    en: "Expression is the visible or audible manifestation of inner states such as emotions, thoughts or intentions through facial expressions, speech or gestures.",
  },
  JOY: {
    de: "Freude ist ein positives Gefühl, das als Reaktion auf angenehme Erlebnisse, Gedanken oder Erwartungen entsteht.",
    en: "Joy is a positive emotion that arises in response to pleasant experiences, thoughts or expectations.",
  },
};

// Locale-aware lookup; anything that is not German falls back to English.
export function elementDescription(element: string, locale: string): string | null {
  const entry = ELEMENT_DESCRIPTIONS[element];
  if (!entry) return null;
  return locale.toLowerCase().startsWith("de") ? entry.de : entry.en;
}
